import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'groups', redirectTo: 'groups/list', pathMatch: 'full' },
  {
    path: 'groups',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/groups.component').then((m) => m.GroupsComponent),
      },
      {
        path: 'list/:org_id',
        loadComponent: () => import('./list/groups.component').then((m) => m.GroupsComponent),
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})

export class groupsRoutingModule {
  static routes = admin;
}